import { DeleteRequest, GetRequest, PostRequest, PutRequest } from '../service';

const ControllerName = "AccountManagerOrder"

export const GetAllAMOrders = (link) =>
    GetRequest(ControllerName + link)

export const AMAskForQuotation = (requests) =>
    PostRequest(`${ControllerName}/ask-for-quotation`, requests)

export const    GetAMDetails = (brokerPatientId) =>
    GetRequest(`${ControllerName}/getDetails/${brokerPatientId}`)

export const GetAMOrderQuotationDetials = (medicalOrderId) =>
    GetRequest(`${ControllerName}/getQuotationDetails/${medicalOrderId}`)


export const GetAMOrderProviderQuotationResponseDetails = (hospitalRequestId) =>
    GetRequest(`${ControllerName}/getProviderQuotationResponseDetails/${hospitalRequestId}`)

export const AMAcceptQuotation = (hospitalOrderId ,requestData) =>
    PutRequest(`${ControllerName}/acceptQuotation/${hospitalOrderId}`,requestData)
